import React, { useState, useEffect } from 'react';
import Layout from '../../components/Layout';
import { getUserInfo } from '../../user';
import { Link, Navigate, useLocation } from 'react-router-dom';
import api from '../../api';
import ContractTable from '../../components/ContractTable';
import ContractModal from '../../components/ContractModal';
import { CO_LABEL } from '../../utils/contractLabel';

function useQuery() {
  const { search } = useLocation();
  return React.useMemo(() => new URLSearchParams(search), [search]);
}

export default function Contracts() {
  const [user, setUser] = useState(null);
  const [modalOpen, setModalOpen] = useState(false);
  const [modalCustomerId, setModalCustomerId] = useState(null);
  const [selectedContract, setSelectedContract] = useState(null);
  const [refreshKey, setRefreshKey] = useState(0);
  const query = useQuery();
  const customerId = query.get('customer') ? Number(query.get('customer')) : null;

  const [modalCustomerName, setModalCustomerName] = useState(null);
  // Opened from a customer's "Contracts" button: show whose they are
  const [customer, setCustomer] = useState(null);
  useEffect(() => {
    getUserInfo().then(setUser);
  }, []);
  useEffect(() => {
    setCustomer(null);
    if (!customerId) return;
    api.post('/masterdata/customers', { id: customerId })
      .then((res) => setCustomer(res?.data ?? null))
      .catch(() => setCustomer(null));
  }, [customerId]);

  if (!user) return null;
  if (!Array.isArray(user.roles) || !user.roles.includes('admin')) return <Navigate to="/" replace />;
  return (
    <Layout>
      <div className="flex flex-col sm:flex-row sm:items-center gap-x-4 gap-y-1 mb-4">
        <h1 className="text-2xl font-bold mb-0">
          {customerId ? `${CO_LABEL} for ${customer?.name ?? '...'}` : 'Contracts'}
        </h1>
        {customerId && (
          <Link to="/contracts" className="text-sm font-medium text-emerald-700 hover:underline dark:text-emerald-300">
            All contracts
          </Link>
        )}
      </div>
      <ContractTable
        key={refreshKey}
        customerId={customerId}
        onCreateClick={() => {
        setModalCustomerId(customerId);
        setModalCustomerName(customer?.name ?? null);
        setSelectedContract(null);
        setModalOpen(true);
  }}
        onEdit={(contract) => {
          setSelectedContract(contract);
          setModalCustomerId(contract.customer_id || null);
          setModalCustomerName(contract.customer?.name || null);
          setModalOpen(true);
        }}
      />
      <ContractModal
        open={modalOpen}
        onClose={() => setModalOpen(false)}
        customerId={modalCustomerId}
        customerName={modalCustomerName}
        isAdmin /* the page is admin-only */
        contract={selectedContract}
        onCreated={() => { setModalOpen(false); setRefreshKey(k => k + 1); }}
        onUpdated={() => { setModalOpen(false); setRefreshKey(k => k + 1); }}
      />
    </Layout>
  );
}
